namespace $ { export class $piterjs_others extends $mol_page {

	/**
	 *  ```
	 *  title \Календарь фронтенд событий
	 *  ```
	 **/
	title() {
		return "Календарь фронтенд событий"
	}

	/**
	 *  ```
	 *  tools /
	 *  	<= Add
	 *  	<= Close
	 *  ```
	 **/
	tools() {
		return [this.Add() , this.Close()] as readonly any[]
	}

	/**
	 *  ```
	 *  Add $mol_link
	 *  	uri \https://github.com/web-standards-ru/calendar
	 *  	target \_blank
	 *  	hint \Добавить ещё событие
	 *  	sub / <= Add_icon
	 *  ```
	 **/
	@ $mol_mem
	Add() {
		return (( obj )=>{
			obj.uri = () => "https://github.com/web-standards-ru/calendar"
			obj.target = () => "_blank"
			obj.hint = () => "Добавить ещё событие"
			obj.sub = () => [this.Add_icon()] as readonly any[]
			return obj
		})( new this.$.$mol_link(  ) )
	}

	/**
	 *  ```
	 *  Add_icon $mol_icon_plus
	 *  ```
	 **/
	@ $mol_mem
	Add_icon() {
		return (( obj )=>{
			return obj
		})( new this.$.$mol_icon_plus(  ) )
	}

	/**
	 *  ```
	 *  Close $mol_link
	 *  	arg * others null
	 *  	sub / <= Close_icon
	 *  ```
	 **/
	@ $mol_mem
	Close() {
		return (( obj )=>{
			obj.arg = () => ({
			"others" :  null as any ,
		})
			obj.sub = () => [this.Close_icon()] as readonly any[]
			return obj
		})( new this.$.$mol_link(  ) )
	}

	/**
	 *  ```
	 *  Close_icon $mol_icon_cross
	 *  ```
	 **/
	@ $mol_mem
	Close_icon() {
		return (( obj )=>{
			return obj
		})( new this.$.$mol_icon_cross(  ) )
	}

	/**
	 *  ```
	 *  body / <= Events
	 *  ```
	 **/
	body() {
		return [this.Events()] as readonly any[]
	}

	/**
	 *  ```
	 *  Events $mol_list rows <= events
	 *  ```
	 **/
	@ $mol_mem
	Events() {
		return (( obj )=>{
			obj.rows = () => this.events()
			return obj
		})( new this.$.$mol_list(  ) )
	}

	/**
	 *  ```
	 *  events /$mol_view
	 *  ```
	 **/
	events() {
		return [] as readonly ( $mol_view )[]
	}

	/**
	 *  ```
	 *  Event!uid $piterjs_others_event
	 *  	title <= event_title!uid
	 *  	uri <= event_uri!uid
	 *  	start <= event_start!uid
	 *  	location <= event_location!uid
	 *  ```
	 **/
	@ $mol_mem_key
	Event( uid : any ) {
		return (( obj )=>{
			obj.title = () => this.event_title(uid)
			obj.uri = () => this.event_uri(uid)
			obj.start = () => this.event_start(uid)
			obj.location = () => this.event_location(uid)
			return obj
		})( new this.$.$piterjs_others_event(  ) )
	}

	/**
	 *  ```
	 *  event_title!uid \
	 *  ```
	 **/
	event_title( uid : any ) {
		return ""
	}

	/**
	 *  ```
	 *  event_uri!uid \
	 *  ```
	 **/
	event_uri( uid : any ) {
		return ""
	}

	/**
	 *  ```
	 *  event_start!uid $mol_time_moment
	 *  ```
	 **/
	@ $mol_mem_key
	event_start( uid : any ) {
		return (( obj )=>{
			return obj
		})( new this.$.$mol_time_moment(  ) )
	}

	/**
	 *  ```
	 *  event_location!uid \
	 *  ```
	 **/
	event_location( uid : any ) {
		return ""
	}

} }
